import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActionBar = ({ 
  onAddDish, 
  onImportMenu, 
  onExportData,
  onGenerateQR 
}) => {
  return (
    <div className="quick-action-bar bg-card border border-border rounded-lg p-3 md:p-4 shadow-warm mb-4 md:mb-6">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <h2 className="text-base md:text-lg font-heading font-semibold text-foreground">
          Actions rapides
        </h2>
        <div className="flex flex-wrap items-center gap-2 sm:ml-auto">
          <Button
            variant="default"
            onClick={onAddDish}
            iconName="Plus"
            iconPosition="left"
            iconSize={18}
            className="flex-1 sm:flex-none"
          >
            Ajouter un plat
          </Button>
          <Button
            variant="outline"
            onClick={onImportMenu}
            iconName="Upload"
            iconPosition="left"
            iconSize={18}
            className="flex-1 sm:flex-none"
          >
            Importer
          </Button>
          <Button
            variant="outline"
            onClick={onExportData}
            iconName="Download"
            iconPosition="left"
            iconSize={18}
            className="flex-1 sm:flex-none"
          >
            Exporter
          </Button>
          <Button
            variant="secondary"
            onClick={onGenerateQR}
            iconName="QrCode"
            iconPosition="left"
            iconSize={18}
            className="flex-1 sm:flex-none"
          >
            Codes QR
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionBar;